import { useContext, useEffect, useState } from "react";
import Chart from "react-google-charts";
import { useSelector } from "react-redux";
import { getIndEmplWagesPieChart } from "../../../../Pagat/wages/utils/calculations";
import "./EmployeeWageCard.scss";
import { Alert } from "antd";
import PunonjesitContext from "../../../store/PunonjesitContext";

function EmployeeWageCard({ employee }) {
  const { specsData } = useContext(PunonjesitContext);
  const { employees } = useSelector((state) => state.employeesList);
  const { programFields } = useSelector((state) => state.programFields);
  const [wageDataSet, setWageDataSet] = useState([]);

  const clockings = specsData?.clockings;
  const wages = specsData?.wages;
  const employeeRequests = specsData?.employeeRequests;
  const prepayments = specsData?.prepayments;

  useEffect(() => {
    if (
      !!employeeRequests &&
      !!programFields &&
      !!employees &&
      !!clockings &&
      !!wages &&
      !!prepayments &&
      employee?.employeeId
    ) {
      setWageDataSet(
        getIndEmplWagesPieChart(
          employee?.employeeId,
          wages,
          clockings,
          employeeRequests,
          employees,
          prepayments,
          programFields,
          specsData?.startMs != null && specsData?.endMs != null
            ? { startMs: specsData.startMs, endMs: specsData.endMs }
            : undefined
        )
      );
    }
  }, [
    employees,
    clockings,
    programFields,
    wages,
    employeeRequests,
    prepayments,
    employee?.employeeId,
    specsData?.startMs,
    specsData?.endMs,
  ]);

  return (
    <div className="employee_wage_card">
      {wageDataSet.length > 0 && wageDataSet[1][1] !== 0 ? (
        <>
          <br />
          <br />
          <Chart
            chartType="PieChart"
            width="100%"
            height="100%"
            data={wageDataSet}
            options={{ chartArea: { width: 350, height: 300 }, is3D: true }}
          />
        </>
      ) : (
        <>
          {Array.from(Array(5)).map((_, i) => (
            <br key={i} />
          ))}
          <Alert
            type="info"
            showIcon
            message={
              specsData?.periodLabel
                ? `Nuk ka të dhëna për ${specsData.periodLabel}`
                : "Nuk ka të dhëna page për punonjësin!"
            }
          />
        </>
      )}
    </div>
  );
}

export default EmployeeWageCard;
